import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Form, Formik } from "formik";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import Footer from "../../../Components/Footer/footer";

import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import CustomInput from "../../../CustomComponent/custom_input";

import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import SimpleButton from "../../../Components/layouts/simple_button";
import { CreateOrderSchema } from "../../../Schemas/Schedule siteInspection/createOrderShcema";

function CreateOrder() {
  const navigate = useNavigate();
  let userData = useSelector((store) => store.login.user);

  const [loading, setLoading] = useState(false);

  const handelSubmit = (values) => {
    // values.generatedBy = userData?.UserId;
    setLoading(true);
    performRequest("POST", `/bookSiteInspection/createSiKitOrder/`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Order Created Successfully");
          navigate("/si-schedules");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="card my-4">
              <div className="card-header">
                <h2 className="page-title">Add Order Details</h2>
              </div>

              <Formik
                initialValues={{
                  name: "",
                  email: "",
                  contactNumber: "",
                  orderId: "",
                }}
                validationSchema={CreateOrderSchema}
                enableReinitialize
                onSubmit={handelSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-12">
                          {/* Name */}
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Order Id
                            </label>
                            <div className="col-lg-9">
                              {" "}
                              <CustomInput name="orderId" type="text" />
                              {props.touched.orderId &&
                                props.errors.orderId && (
                                  <p className="text-danger">
                                    {props.errors.orderId}
                                  </p>
                                )}{" "}
                            </div>
                          </div>

                          {/* Name */}
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">Name</label>
                            <div className="col-lg-9">
                              {" "}
                              <CustomInput name="name" type="text" />
                              {props.touched.name && props.errors.name && (
                                <p className="text-danger">
                                  {props.errors.name}
                                </p>
                              )}{" "}
                            </div>
                          </div>

                          {/* Email */}
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">Email</label>
                            <div className="col-lg-9">
                              <CustomInput name="email" type="text" />
                              {props.touched.email && props.errors.email && (
                                <p className="text-danger">
                                  {props.errors.email}
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Contact Number */}
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Contact Number
                            </label>
                            <div className="col-lg-9">
                              <CustomInput name="contactNumber" type="text" />
                              {props.touched.contactNumber &&
                                props.errors.contactNumber && (
                                  <p className="text-danger">
                                    {props.errors.contactNumber}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        <FormSubmitButton buttonText="Submit" />
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
}

export default CreateOrder;
